export default __webpack_public_path__ + "static/media/truck-transit.abeae177.jpg";